import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionBanner.css';

export const SubscriptionBanner: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    navigate('/profile');
  };

  return (
    <div className="subscription-banner">
      <div className="subscription-banner__content">
        <div className="subscription-banner__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div className="subscription-banner__message">
          <h4>Subscription Required</h4>
          <p>You need an active subscription to access these features. Update your subscription details to continue.</p>
        </div>
        <button 
          className="subscription-banner__button"
          onClick={handleGoToProfile}
        >
          Go to Profile
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </button>
      </div>
    </div>
  );
};
